module.exports = __webpack_public_path__ + "static/img/12.a05afe6e.jpg";